// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__5eP9X","container":"styles_container__jaBGH","footer":"styles_footer__uv05H"};